import { Data } from "../types";

import { HeadCell } from "@/components/app/EnhancedTableHeader/type";

const headCells: HeadCell<Data>[] = [
    {
        id: "id",
        numeric: true,
        disablePadding: true,
        label: "ID",
    },
    {
        id: "title",
        numeric: false,
        disablePadding: true,
        label: "Title",
    },
    {
        id: "isActive",
        numeric: false,
        disablePadding: true,
        label: "State",
    },
    {
        id: "contentCount",
        numeric: false,
        disablePadding: true,
        label: "Content Count",
    },
    {
        id: "contactName",
        numeric: false,
        disablePadding: true,
        label: "Contact Name",
    },
    {
        id: "contactPhone",
        numeric: false,
        disablePadding: true,
        label: "Contact Phone",
    },
    {
        id: "contactEmail",
        numeric: false,
        disablePadding: true,
        label: "Contact Email",
    },
    {
        id: "createdAt",
        numeric: false,
        disablePadding: true,
        label: "Created At",
    },
    {
        id: "updatedAt",
        numeric: false,
        disablePadding: true,
        label: "Updated At",
    },
];

export default headCells;
